import { useCallback, useMemo } from "react";
import { t } from "@/i18n-js/instance";
import { useSelectedBlock } from "./useBuilderStore";

export const useSelectedBlockActions = () => {
  const {
    canMoveUp,
    canMoveDown,
    moveSelectedBlock,
    removeSelectedBlock,
    duplicateSelectedBlock,
    resetBlockStyle,
    copyBlockId,
  } = useSelectedBlock();

  const onRemoveHandler = useCallback(() => {
    // TODO: Add confirmation modal
    removeSelectedBlock();
  }, [removeSelectedBlock]);

  return useMemo(
    () => [
      {
        label: t("builder_ui.editor.move_up"),
        value: "move_up",
        isDisabled: !canMoveUp,
        onClick: () => moveSelectedBlock("up"),
      },
      {
        label: t("builder_ui.editor.move_down"),
        value: "move_down",
        isDisabled: !canMoveDown,
        onClick: () => moveSelectedBlock("down"),
      },
      {
        label: t("builder_ui.editor.duplicate"),
        value: "duplicate",
        onClick: duplicateSelectedBlock,
      },
      {
        label: t("builder_ui.editor.copy_block_id"),
        value: "copy_block_id",
        onClick: copyBlockId,
      },
      {
        label: t("builder_ui.editor.reset_styles"),
        value: "reset_styles",
        color: "text-v2-danger",
        onClick: resetBlockStyle,
      },
      {
        label: t("builder_ui.editor.remove"),
        value: "remove",
        color: "text-v2-danger",
        onClick: onRemoveHandler,
      },
    ],
    [
      canMoveDown,
      canMoveUp,
      duplicateSelectedBlock,
      moveSelectedBlock,
      onRemoveHandler,
      resetBlockStyle,
      copyBlockId,
    ],
  );
};
